<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h1 class="text-h3 mb-4">Мониторинг системы</h1>
        <v-card>
          <v-card-text>
            <p class="text-body-1">Страница мониторинга системы (только для администраторов)</p>
            <!-- TODO: Add system monitoring charts and metrics -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SystemMonitoring'
};
</script>